import React, { useState } from "react";
import "../header.scss";
import { FiMenu } from "react-icons/fi";
import MobileMenu from "./MobileMenu.js";
import logo from "../../images/logo.svg";
import { Link } from "react-scroll";
const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <div className="containerNav">
      <div className="headerContainer">
        <div className="logo">
          <img src={logo} />
        </div>
        <div>
          <nav>
            <ul className="menu">
              <li>
                <Link to="home" smooth={true}>
                  Product
                </Link>
              </li>
              <li>
                <Link to="useCases" smooth={true}>
                  Use Case
                </Link>
              </li>
              <li>
                <Link to="learn" smooth={true}>
                  Learn
                </Link>
              </li>
              <li>
                <Link to="pricing" smooth={true}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="contact" smooth={true}>
                  Comparison
                </Link>
              </li>
              <li>
                <Link to="form" smooth={true}>
                  Contact Sales
                </Link>
              </li>
            </ul>
          </nav>
        </div>
        <span className="controlContainer">
          <div className="nav_btns">
            <a href="#" className="rounded_btn">
              Sign Up
            </a>
            <div className="select">
              <select defaultValue="value1" name="select">
                <option value="value1">EN</option>
                <option value="value2">UA</option>
                <option value="value3">DE</option>
              </select>
            </div>
          </div>
          <div
            onClick={() => setOpenMenu((openMenu) => !openMenu)}
            className="mobileMenu"
          >
            <FiMenu />
          </div>
        </span>
      </div>
      <MobileMenu
        isOpen={openMenu}
        close={() => setOpenMenu((openMenu) => !openMenu)}
      />
    </div>
  );
};

export default Header;
